import { createTheme } from "@mui/material/styles";

const appTheme = createTheme({
  typography: {},
  palette: {
    primary: {
      main: "#686565",
    },
    secondary: {
      main: "#399bc1",
    },
    background: {
      default: "#fff",
    },
    text: {
      primary: "#686565",
      secondary: "#686565",
    },
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: "2.5em",
          color: "#686565",
        },
        h4: {
          fontSize: "1.5em",

          color: "#686565",
        },
        h5: {
          fontSize: "1em",
          color: "#686565",
        },
        body2: {
          color: "#686565",
        },
        subtitle1: {
          color: "#686565",
        },
      },
    },
  },
});

export default appTheme;
